/**
 * Acciones para agregar clientes en la gestión de clientes
 * gc_ac_ = Gestión de Clientes (gc) _ Agregar Cliente (ac)
 */
import {Dispatch} from 'react'
import * as http from '../../../api/http'
import {ENDPOINTS} from '../../../api/config'
import {State} from '../../../reducers'
import {
  generalOpenModalError,
  generalOpenModalMessage,
  generalShowLoader,
} from '../../general.actions'
import {GestionClienteAction} from '../../../interfaces/gestion-cliente.interface'
import {KEYS} from '../../../constants/keysStorage'
import {
  facturacionFormClienteAddError,
  facturacionFormClienteClear,
} from '../../facturacion/facturacionCliente.actions'
import {bloqueaPorDistrito, MENSAJE_DISTRITO_BLOQUEA_V2, MENSAJE_DISTRITO_REQUERIDO} from '../../../utils/normativa.utils'
import {MENSAJE_CORREO_RECEPTOR_INVALIDO, validarCorreosReceptor} from '../../../utils/correo.utils'

// ******************************************************************************************
// ? PETICIONES HTTP
// ******************************************************************************************
export const gc_ac_CreateCliente =
  (onSuccess?: () => void) => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))

    const formCliente = getState().facturacion.formCliente
    const codigoempresa = localStorage.getItem(KEYS.CODIGO_EMPRESA)
    const id_user = localStorage.getItem(KEYS.ID_CLIENT)

    // Validaciones mínimas requeridas
    if (!formCliente?.tipoDocumento) {
      dispatch(generalShowLoader(false))
      return dispatch(generalOpenModalError('El tipo de documento es obligatorio'))
    }
    if (!formCliente?.numId) {
      dispatch(generalShowLoader(false))
      return dispatch(generalOpenModalError('El número de identificación es obligatorio'))
    }
    if (!formCliente?.nombre) {
      dispatch(generalShowLoader(false))
      return dispatch(generalOpenModalError('El nombre del cliente es obligatorio'))
    }

    if (formCliente?.departamento && bloqueaPorDistrito(getState().catalogos.datosEmisor, formCliente?.distrito)) {
      dispatch(generalShowLoader(false))
      dispatch(facturacionFormClienteAddError({distrito: MENSAJE_DISTRITO_REQUERIDO}))
      return dispatch(generalOpenModalError(MENSAJE_DISTRITO_BLOQUEA_V2))
    }

    // Consolidar todos los correos: chips + el valor escrito en el input
    // El input puede contener múltiples correos separados por coma
    const allEmails = [...(formCliente.chipsEmail ?? [])]
    const emailInput = formCliente.email?.trim()
    if (emailInput) {
      const parsed = emailInput.split(',').map((e: string) => e.trim()).filter((e: string) => e)
      parsed.forEach((e: string) => {
        if (!allEmails.includes(e)) allEmails.push(e)
      })
    }

    const correoInvalido = validarCorreosReceptor(formCliente.email, formCliente.chipsEmail)
    if (correoInvalido) {
      dispatch(generalShowLoader(false))
      dispatch(facturacionFormClienteAddError({email: correoInvalido}))
      return dispatch(generalOpenModalError(`${correoInvalido} ${MENSAJE_CORREO_RECEPTOR_INVALIDO}`))
    }

    const body = {
      codigoempresa: codigoempresa,
      tipodocumento: formCliente.tipoDocumento,
      numdocumento: formCliente.numId,
      nombre: formCliente.nombre,
      direccion: formCliente.direccion ?? '',
      email: allEmails[0] ?? '',
      telefono: formCliente.telefono ?? '',
      nrc: formCliente.nrc ?? '',
      codactividad: formCliente.actividad ?? '',
      descactividad: formCliente.descripcion ?? '',
      departamento: formCliente.departamento ?? '',
      municipio: formCliente.municipio ?? '',
      ...(formCliente.distrito ? {distrito: formCliente.distrito} : {}),
      correos_adicionales: allEmails.slice(1),
      usuariocreacion: id_user,
      correocc: formCliente.correocc ?? '',
    }

    await http
      .post(ENDPOINTS.GESTION_CLIENTES_CREATE_CLIENTE, body)
      .then(async (res: any) => {
        dispatch(generalShowLoader(false))
        await dispatch(
          generalOpenModalMessage('Cliente creado', res?.data?.message ?? 'El cliente ha sido creado exitosamente.')
        )
        dispatch(facturacionFormClienteClear())
        if (onSuccess) onSuccess()
      })
      .catch(async (err: any) => {
        const internalMsg = err?.response?.data?.internalMessage ?? ''
        const isDuplicate = internalMsg.toLowerCase().includes('ya existe un cliente')
        const displayMsg = isDuplicate
          ? 'Ya existe un cliente con ese número de documento'
          : err?.response?.data?.message ?? 'No se pudo crear el cliente'
        await dispatch(generalOpenModalError(displayMsg, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }
